import Recent from 'components/ContinueConversation/components/Recent/Recent';
import { AppContext } from 'Utils/Contexts';
import { AppState } from 'Utils/Enums';
import React, { useContext, useEffect, useState } from 'react'
import styles from "./AllConversation.module.scss";



export default function AllConversation(props) {

    const appStateContext = useContext(AppContext);
    const [hideClass, setHideClass] = useState("");

    useEffect(() => {
        switch (appStateContext) {
            case AppState.home:
                setHideClass(styles["hide-right"]);
                break;
            case AppState.chat:
                setHideClass(styles["hide-left"]);
                break;
            default:
                setHideClass("");
                break;
        }
    }, [appStateContext, hideClass]);

    return (
        <div className={`${styles.container} ${hideClass}`}>
            <Recent></Recent>
            <br />
            <br />
            <br />
        </div>
    )
}
